import React, { useState } from "react";
import { InputAdornment, TextField} from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';
import { useLocation} from "react-router-dom";
// import { useHistory } from 'react-router-dom';


function useQuery() {
  return new URLSearchParams(useLocation().search);
}


function SearchBox(props){
  const { fetchData, placeholder } = props;
  // const location = useLocation();  
  let query = useQuery();  
  // let history = useHistory();  

  // pagination  
  // const [countPages, setCountPages] = useState(location.state && location.state.countPages ? location.state.countPages: 0 );
  const [searchText, setSearchText] = useState(query.get("searchText")  || "");

  

  const [timer, setTimer] = useState(null);

  const onSearchChanged = e => {
    const value = e.target.value;
    setSearchText(value);      
    clearTimeout(timer)
    const newTimer = setTimeout(() => {
      if(value){                
        // history.push({ searchText: searchText });
        // query.set('searchText', value);
        // history.push({ search: `?searchText=${value}` });
      }
      fetchData(value);
      
    }, 500)
    setTimer(newTimer)
  }

  return(
    // Show Empty courses    
    <div className="search-box">
      <TextField id="standard-search" type="search"  fullWidth placeholder={placeholder} color="primary" onChange={onSearchChanged} variant="outlined" value={searchText}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),            
        shrink: "true",
      }}
      />
    </div> 
  );
}

export default SearchBox;